module.exports = __webpack_public_path__ + "media/images/right-699756effa232f2710ee4e4245590d40.png";